import { render, staticRenderFns } from "./CoffInputText.vue?vue&type=template&id=313fb341&scoped=true"
import script from "./CoffInputText.vue?vue&type=script&lang=js"
export * from "./CoffInputText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313fb341",
  null
  
)

export default component.exports